import {
  SUMMARYOFGOVERNANCEPROJECTS
} from 'actions/pzCustom/summaryOfGovernanceProjects';
export const initialState = {
  isFetching: false,
  data: []
};
export const summaryOfGovernanceProjectsList = (state = initialState, action) => {
  switch (action.type) {
    case `${SUMMARYOFGOVERNANCEPROJECTS}_PENDING`:
      return Object.assign({}, initialState, {
        isFetching: true
      });
    case `${SUMMARYOFGOVERNANCEPROJECTS}_SUCCESS`:
      return Object.assign({}, state, {
        isFetching: false,
        data: action.payload.data,
        allData: action.payload
      });
    default:
      return state;
  }
};

